"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    paddingRight: palette.gutter + 'px',
    paddingLeft: palette.gutter * 2 + 'px',
    idleBackground: palette.elPrimary,
    idleBorderStyle: 'none',
    idleBorderRadius: '2px',
    idleBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    focusBackground: palette.elPrimary,
    focusBorderStyle: 'none',
    focusBorderRadius: '2px',
    focusBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    hoverBackground: palette.elPrimary,
    hoverBorderStyle: 'none',
    hoverBorderRadius: '2px',
    hoverBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    errorBackground: palette.elPrimary,
    errorBorderStyle: 'none',
    errorBorderRadius: '2px',
    errorBoxShadow: "0 2px 4px 0 ".concat(palette.elShadowMain),
    disabledBackground: palette.elPrimary,
    disabledBorderStyle: 'none',
    disabledBorderRadius: '2px',
    disabledBoxShadow: 'none',
    listOffsetTop: 8,
    listOffsetBottom: 8
  };
}